import { createSelector } from 'redux-orm';
import { orm } from 'model';
import { DEFAULT_MODEL_REF_ARRAY } from 'consts';

const debitCardSelector = createSelector(
  orm,
  (state, payerId) => payerId,
  ({ DebitCard, Payer }, payerId) => {
    if (payerId == null) {
      return DEFAULT_MODEL_REF_ARRAY;
    }

    const normalizedPayerId = String(payerId);
    const debitCards = Payer.idExists(payerId)
      ? Payer.withId(payerId).debitCards.toRefArray()
      : DebitCard.filter(
          ({ payerId: debitCardPayerId }) =>
            String(debitCardPayerId) === normalizedPayerId
        ).toRefArray();

    if (!debitCards?.length) {
      return DEFAULT_MODEL_REF_ARRAY;
    }

    const allowedStatuses = new Set(['active', 'inactive', 'expired']);

    return debitCards.filter((card) => {
      const cardType = String(card.cardType || '').toLowerCase();
      const cardStatus = String(card.cardStatus || '').toLowerCase();
      const cardInternal = String(card.cardInternal || '').toLowerCase();
      const cardPayerId = String(card.payerId ?? '');

      return (
        cardPayerId === normalizedPayerId &&
        cardType === 'dc' &&
        allowedStatuses.has(cardStatus) &&
        cardInternal === 'off'
      );
    });
  }
);

export default debitCardSelector;
